import { useCallback } from 'react';
import { Restaurant } from '../types';
import { isRestaurantOpen as checkOpen, getNextOpeningTime as getNextTime } from '../utils/restaurantUtils';

export const useRestaurantStatus = (restaurant: Restaurant | null) => {
  const isRestaurantOpen = useCallback(() => {
    return checkOpen(restaurant);
  }, [restaurant]);

  // Function to get next opening time
  const getNextOpeningTime = useCallback(() => {
    const nextTime = getNextTime(restaurant);
    // Extract only the time if it's "Hoje às HH:MM", or keep it as is
    return nextTime.includes('Hoje às ') ? nextTime.replace('Hoje às ', '') : nextTime;
  }, [restaurant]);

  // Function to get closing time
  const getClosingTime = useCallback(() => {
    if (!restaurant || !restaurant.openingHours) return '';

    const now = new Date();
    const currentDay = now.getDay(); // 0-6 (Sunday-Saturday)
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTimeInMinutes = currentHour * 60 + currentMinute;

    // Get today's hours
    const todayHours = restaurant.openingHours.find(h => h.dayOfWeek === currentDay);
    if (todayHours && todayHours.timeSlots && todayHours.timeSlots.length > 0) {
      // Find the current time slot (if restaurant is open)
      for (const timeSlot of todayHours.timeSlots) {
        const [openHour, openMinute] = timeSlot.open.split(':').map(Number);
        const [closeHour, closeMinute] = timeSlot.close.split(':').map(Number);

        const openTimeInMinutes = openHour * 60 + openMinute;
        const closeTimeInMinutes = closeHour * 60 + closeMinute;

        // Check if current time is between opening and closing hours
        if (currentTimeInMinutes >= openTimeInMinutes && currentTimeInMinutes <= closeTimeInMinutes) {
          return timeSlot.close;
        }
      }
    }

    return '';
  }, [restaurant]);

  return {
    isRestaurantOpen,
    getNextOpeningTime,
    getClosingTime
  };
};
